// Actions
export const CLIENT_FETCH  = '[Client] Fetch'

// Mutations
export const CLIENT_META   = '[Client] meta'
export const CLIENT_OBTAIN = '[Client] obtain'
export const CLIENT_CLEAR  = '[Client] clear'
export const CLIENT_SET_LOADING = '[Client] set loading'
